<template>
  <el-container class="admin-user-container">
    <el-header height="auto" class="search-header">
      <el-form :inline="true" :model="queryParams" size="small" class="search-form" @submit.native.prevent>
        <el-form-item class="search-actions">
          <el-button icon="el-icon-refresh" class="btn-refresh" @click="onRefresh">刷新</el-button>
        </el-form-item>
      </el-form>
    </el-header>

    <el-main class="table-main">
      <el-table
        v-loading="loading"
        :data="dataList"
        border
        stripe
        height="520"
        style="width: 100%"
        class="custom-table"
      >
        <el-table-column
          fixed="left"
          label="No"
          type="index"
          align="center"
        />

        <el-table-column
          label="头像"
          width="80"
          align="center"
        >
          <template slot-scope="scope">
            <el-avatar
              :size="36"
              :src="scope.row.avatarUrl"
              icon="el-icon-user-solid"
              class="table-avatar"
            />
          </template>
        </el-table-column>

        <el-table-column
          prop="userId"
          label="用户 ID"
          align="center"
        />

        <el-table-column
          prop="screenName"
          label="显示名"
        >
          <template slot-scope="scope">
            <router-link :to="`/user/${scope.row.userIdStr}`" class="user-link">
              <span>{{ scope.row.screenName }}</span>
              <i class="el-icon-link link-icon" />
            </router-link>
          </template>
        </el-table-column>

        <el-table-column
          prop="totalSessions"
          label="会话数量"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="handleSessions(scope.row)"
            >
              {{ scope.row.totalSessions }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes"
          :page-sizes="[10, 12, 20, 50]"
          :page-size="pageSize"
          :current-page="currentPage"
          :total="totalSize"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>

      <!-- 会话明细弹窗 -->
      <el-dialog
        :title="dialogTitle"
        :visible.sync="sessionDialogVisible"
        width="60%"
        @close="handleCloseDialog"
      >
        <!-- 弹窗内的表格 -->
        <el-table
          v-loading="sessionLoading"
          :data="sessionTableData"
          border
          stripe
          style="width: 100%"
        >
          <el-table-column prop="lastActiveTime" label="最近访问时间" align="center" />
          <el-table-column prop="loginTime" label="登录时间" align="center" />
          <el-table-column prop="loginIp" label="登录 IP" align="center" />
          <el-table-column prop="loginIp" label="登录位置" align="center" />
          <el-table-column prop="userAgent" label="登录设备" align="center" />
        </el-table>

        <span slot="footer" class="dialog-footer">
          <el-button @click="sessionDialogVisible = false">关 闭</el-button>
        </span>
      </el-dialog>
    </el-main>
  </el-container>
</template>

<script>
import { getAccountOnline, getAccountSession } from '@/api/admin'

export default {
  name: 'AdminAccountOnline',
  data() {
    return {
      queryParams: {
        pn: 1,
        status: '', // 初始化为空字符串，以便触发 el-select 的 clearable
        screenName: '',
        userId: ''
      },
      currentPage: 1,
      pageSize: 12,
      totalSize: 0,
      dataList: [],
      loading: false,
      dialogTitle: '',
      sessionDialogVisible: false, // 控制弹窗显示隐藏
      sessionLoading: false, // 弹窗内部表格的 loading 动画
      sessionTableData: [] // 弹窗表格的数据源
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      this.queryParams.pn = this.currentPage
      getAccountOnline(this.queryParams).then(resp => {
        if (resp.code === 0) {
          const respData = resp.data
          this.pageSize = respData.pageSize
          this.dataList = respData.list || []
          this.totalSize = respData.totalSize || 0
        } else {
          this.$message.warning(resp.msg)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 点击查询或下拉切换时调用
    handleSearch() {
      this.currentPage = 1 // 搜索时重置回第一页
      this.getData()
    },
    // 重置/刷新
    onRefresh() {
      this.queryParams.screenName = ''
      this.queryParams.status = ''
      this.currentPage = 1
      this.getData()
      this.$message.success('数据已刷新')
    },
    handleCurrentChange(pageNumber) {
      this.currentPage = pageNumber
      this.getData()
      // 丝滑滚动回顶部
      const tableBody = this.$el.querySelector('.el-table__body-wrapper')
      if (tableBody) tableBody.scrollTop = 0
    },
    handleSizeChange(newSize) {
      this.pageSize = newSize
      this.currentPage = 1
      this.getData()
    },
    handleSessions(row) {
      this.sessionLoading = true
      this.sessionTableData = []

      const queryParams = {
        userId: row.userId
      }
      getAccountSession(queryParams).then(resp => {
        if (resp.code === 0) {
          this.dialogTitle = row.userId + ' 的在线会话明细'
          this.sessionTableData = resp.data
          this.sessionDialogVisible = true
        } else {
          this.$message.warning(resp.msg)
        }
      }).finally(() => {
        this.sessionLoading = false
      })
    },
    handleCloseDialog() {
      this.sessionTableData = []
      this.sessionLoading = false
    }
  }
}
</script>

<style scoped>
/* 容器精细布局 */
.admin-user-container {
  background: #fff;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
}

/* 顶部搜索栏现代化微调 */
.search-header {
  padding: 16px 4px 4px 4px;
  border-bottom: 1px solid #f1f5f9;
}
.search-form {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 16px;
}
::v-deep .el-form-item {
  margin-bottom: 12px;
}
::v-deep .el-form-item__label {
  color: #64748b;
  font-weight: 500;
  padding-right: 8px;
}
.search-input {
  width: 200px;
}
.status-select {
  width: 130px;
}
.btn-refresh {
  background: #f8fafc;
  border-color: #cbd5e1;
  color: #64748b;
}
.btn-refresh:hover {
  color: #1890ff;
  border-color: #1890ff;
  background: #fff;
}

/* 表格主体美化 */
.table-main {
  padding: 16px 0 0 0;
}
.custom-table {
  border-radius: 6px;
  overflow: hidden;
}

/* 只保留需要的行内溢出裁剪，优化自带 tooltip 样式 */
.ellipsis-text {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #334155;
}
.text-muted {
  color: #94a3b8;
}

/* 头像与连接项美化 */
.table-avatar {
  border: 1px solid #e2e8f0;
  background-color: #f8fafc;
  box-shadow: 0 2px 6px rgba(0,0,0,0.02);
}
.user-link {
  color: #1890ff;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-weight: 500;
}
.user-link:hover {
  color: #40a9ff;
  text-decoration: underline;
}
.link-icon {
  font-size: 12px;
  opacity: 0.7;
}

/* 角色标签容器包裹弹性盒模型 */
.role-tags-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
.role-tag {
  border-radius: 4px;
  border: 1px solid #fee2e2;
  background: #fff7ed;
  color: #ea580c;
}

/* 操作项去纽扣化改文字 */
.btn-action-delete {
  color: #ef4444;
  font-weight: 500;
  padding: 0;
}
.btn-action-delete:hover {
  color: #dc2626;
}
.btn-action-delete.is-disabled {
  color: #cbd5e1;
}

/* 底部分页精细对齐 */
.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-gradient: linear-gradient(135deg, #1890ff 0%, #0076e4 100%);
  background-color: #1890ff;
}
</style>
